import React, { createContext, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import { useTranslation } from "react-i18next";

import CalenderView from "./CalenderView";
import PrimaryButton from "../../utils/buttons/primaryButton";
import TimeView from "./TimeView";
import { setUsedCarSettingInfo } from "../../../redux/usedCarsSlice";
import axiosInstance, {
  notifySuccess,
  notifyWarning,
} from "../../../utility/axiosInstance";
import {
  fetchUsedCars,
  fetchUsedCarsSettingInfo,
} from "../../../redux/usedCarsThunk";
import { getUsedCarData } from "../../../utility/api";
import { AiOutlineLoading } from "react-icons/ai";
import {
  compareTwoDate,
  compareTwoDateIFG,
  convertToUTCDate,
} from "../../../utility/utils";

export const UsedCarSettingContext = createContext({});

export default function UsedCarSettingIndex({ tab, setTab }) {
  const { t } = useTranslation();

  const weekdays = [
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday",
    "Sunday",
  ];

  const wkDays = {
    ["Monday"]: false,
    ["Tuesday"]: false,
    ["Wednesday"]: false,
    ["Thursday"]: false,
    ["Friday"]: false,
    ["Saturday"]: false,
    ["Sunday"]: false,
  };

  const [usedCars, setUsedCars] = useState([]);

  const { usedCarSettingInfo, list } = useSelector((state) => state.usedCars);

  const dispatch = useDispatch();

  const [weeklyCheckbox, setWeeklyCheckbox] = useState({
    Monday: false,
    Tuesday: false,
    Wednesday: false,
    Thursday: false,
    Friday: false,
    Saturday: false,
    Sunday: false,
  });
  const [workingTime, setWorkingTime] = useState({
    start: "9:00",
    end: "18:00",
  });
  const [tempTimeSave, setTempTimeSave] = useState([]);

  const [workingDayTime, setWorkingDayTime] = useState([]);
  const [availableWorkingDays, setAvailableWorkingDays] = useState([]);
  const [holidays, setHolidays] = useState([]);
  const [dateValue, onDateChange] = useState(new Date());
  const [currentMonth, onCurrentMonth] = useState(null);
  const [applyWeeklySetting, SetApplyWeeklySetting] = useState(false);

  const [dataLoading, setLoading] = useState(true);

  const [available, setAvailable] = useState([]);
  const [carList, setCarList] = useState([]);
  const [selectedCars, setSelectedCars] = useState([]);
  const [selectedCar, setSelectedCar] = useState(null);

  useEffect(() => {
    if (usedCarSettingInfo?.length < 1) {
      dispatch(fetchUsedCarsSettingInfo({ dispatch }));
    }
  }, []);

  const compareMonthAndYear = (date1, date2) => {
    const d1 = new Date(date1);
    const d2 = new Date(date2);

    // Compare month and year
    return (
      d1.getMonth() === d2.getMonth() && d1.getFullYear() === d2.getFullYear()
    );
  };

  useEffect(() => {
    if (usedCars?.length > 0) {
      const filtered = usedCars.filter(({ status }) => status == "available");
      setCarList(filtered);
    }
  }, [usedCars]);

  // const onBack = () => {
  // setTab((count) => (count == 0 ? count : count - 1));
  // };
  const onNext = () => {
    if (available.length === 0) {
      toast.warn(t("serviceSettings.dateNotAvailable"));
      return;
    }
    if (selectedCars?.length < 1) {
      toast.warn(t("usedCars.calendar.noVehiclesSelected"));
      return;
    }
    if (usedCarSettingInfo?.length > 0) {
       
       const fineCars = usedCarSettingInfo?.find((car) => {
         if (selectedCars[0] === car.car) {
           return car;
         }
       }); 
    
      // return
      const exist = fineCars?.usedCarMonthSetting?.find((item) =>
        compareMonthAndYear(item.monthYearDate, currentMonth)
      );
      if (!exist) {
        toast.warn(t("serviceSettings.dateNotAvailable"));
        return;
      }
    } else {
      toast.warn(t("serviceSettings.dateNotAvailable"));
      return;
    }
    setTab((count) => (count == 1 ? count : count + 1));
  };
  const reset = () => {
    setHolidays([]);
    setWorkingTime({ start: "9:00", end: "18:00" });
    onCurrentMonth(new Date());
    setWeeklyCheckbox({
      Monday: true,
      Tuesday: true,
      Wednesday: true,
      Thursday: true,
      Friday: true,
      Saturday: true,
      Sunday: true,
    });
  };
  useEffect(() => {
    setLoading(true);
    try {
      if (selectedCars?.length > 0 && usedCarSettingInfo?.length > 0) {
        const exist = usedCarSettingInfo?.filter((settings) => {
          if (selectedCars.includes(settings?.car)) {
            return settings;
          }
        });

        if (exist?.length > 0) {
          const {
            workingDetails: { workingTime, weeklySetting },
            holidays,
            usedCarMonthSetting,
          } = exist[0];

          if (!currentMonth) {
            const monthYearDateData = usedCarMonthSetting?.find(
              ({ monthYearDate }) =>
                compareMonthAndYear(monthYearDate, new Date())
            );

            if (monthYearDateData?.monthYearDate) {
              onCurrentMonth(
                new Date(monthYearDateData?.monthYearDate).toLocaleDateString()
              );
            }
          }
          if (workingTime && Object.keys(workingTime).length !== 0) {
            setWorkingTime(workingTime);
          }

          if (weeklySetting && Object.keys(weeklySetting).length !== 0) {
            setWeeklyCheckbox(weeklySetting);
          }

          if (holidays) {
            const filterdHolidays = holidays.filter(({ date }) =>
              compareTwoDateIFG(date, new Date())
            );
            setHolidays(filterdHolidays);
          }
        } else {
          reset();
        }
      } else {
        reset();
      }
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  }, [selectedCar, selectedCars, usedCarSettingInfo]);

  const handleMonthDateUpdate = async (body) => {
    try {
      const { usedCarMonthSetting } = body;

      // console.log(body);

      // return
      if (body.usedCars.length < 1) {
        toast.warn(t("usedCars.calendar.noVehiclesSelected"));
        return;
      }
      const response = await axiosInstance.put(
        "usedCarSetting/updateUsedCarSettingInfo",
        {
          ...body,
        }
      );
      // console.log(response);
      if (response?.status === 200) {
        SetApplyWeeklySetting(false);
        dispatch(setUsedCarSettingInfo(response?.data.usedCarSettings));
        notifySuccess(t("usedCars.calendar.updateSuccess"));

        // toast.success("Changed the update");
      }
    } catch (err) {
      console.log(err);
    } finally {
    }
  };
  const handleSingleUpdate = async (body) => {
    try {
      if (body.usedCars.length < 1) {
        toast.warn(t("usedCars.calendar.noVehiclesSelected"));
        return;
      }
      
      console.log(body);
      // return
      const response = await axiosInstance.put(
        "usedCarSetting/updateUsedCarSettingInfoWithDate",
        {
          ...body,
        }
      );

      if (response?.status === 200) {
        dispatch(setUsedCarSettingInfo(response?.data.usedCarSettings));
        notifySuccess(t("usedCars.calendar.updateSuccess"));
        // toast.success("Changed the update");
      }
    } catch (err) {
      console.log(err);
    } finally {
    }
  };
  const onHandleWOS = async (body) => {
    try {
      const response = await handleMonthDateUpdate({
        weeklySetting: weeklyCheckbox,
        usedCars: selectedCar ? [selectedCar] : selectedCars,
      });
    } catch (err) {
      console.log(err);
    } finally {
    }
  };
  useEffect(() => {
    const tempAllDate = [];

    if (available.length > 0) {
      available.forEach((element) => {
        const utcDate = convertToUTCDate(element);
        tempAllDate.push({ date: utcDate, timeSlots: workingDayTime });
      });

      setAvailableWorkingDays(tempAllDate);
    }
  }, [available, workingDayTime]);

  if (dataLoading) {
    <div>
      <AiOutlineLoading className="h-6 w-6 animate-spin m-auto" />
    </div>;
  }
  return (
    <UsedCarSettingContext.Provider
      value={{
        applyWeeklySetting,
        SetApplyWeeklySetting,
        dataLoading,
        handleSingleUpdate,
        handleMonthDateUpdate,
        weeklyCheckbox,
        weekdays,
        setWeeklyCheckbox,
        dateValue,
        onDateChange,
        workingTime,
        setWorkingTime,
        workingDayTime,
        setWorkingDayTime,
        availableWorkingDays,
        setAvailableWorkingDays,
        selectedCars,
        setSelectedCars,
        selectedCar,
        setSelectedCar,
        carList,
        setCarList,
        compareTwoDate,
        holidays,
        setHolidays,
        onHandleWOS,
        currentMonth,
        onCurrentMonth,
        available,
        setAvailable,
        compareMonthAndYear,
        tempTimeSave,
        setTempTimeSave,
        usedCars,
      }}
    >
      <div className="py-8 flex flex-col w-[100%] gap-10">
        {tab === 0 ? (
          <CalenderView />
        ) : (
          <div className="flex flex-col gap-5">
            <TimeView />
          </div>
        )}

        <div className="flex gap-1 justify-end px-10 mb-10 lg:mb-0">
          {tab < 1 && (
            <PrimaryButton width="140px" title={t("next")} onClick={onNext} />
          )}{" "}
        </div>
      </div>
    </UsedCarSettingContext.Provider>
  );
}
